// When new statuses are added they need to be added toa already existing status translations in i18n files
export enum OfferStatus {
  WAITING = 'WAITING',
  OFFER = 'OFFER',
  DONE = 'DONE',
  CANCELLED = 'CANCELLED',
}
